module.exports = __webpack_public_path__ + "img/borders4.06a24b9f.png";